import { render, staticRenderFns } from "./MainButtons.vue?vue&type=template&id=6393d1c2&scoped=true"
import script from "./MainButtons.vue?vue&type=script&lang=js"
export * from "./MainButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6393d1c2",
  null
  
)

export default component.exports